import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MastersDetailedDescription from '../../components/MastersDetailedDescription/MastersDetailedDescription'; 
import BackTo from '../../components/ui/BackTo/BackTo';
import { Masters as MastersEN } from '../../data/masters';
import { Masters as MastersRU } from '../../data/rumasters';
import { Programs as ProgramsEN } from '../../data/programs';
import { Programs as ProgramsRU } from '../../data/ruprograms';
import CourseCard from '../../components/CourseCard/CourseCard';
import './MasterDetailsPage.css';

const MasterDetailsPage: React.FC = () => {
  const { masterId } = useParams(); 
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // ✅ Select data based on the current language
  const Masters = i18n.language === 'ru' ? MastersRU : MastersEN;
  const Programs = i18n.language === 'ru' ? ProgramsRU : ProgramsEN;

  // ✅ Find the master by ID
  const master = Masters.find((m) => m.id === masterId);
  if (!master) {
    return <h2>{t("master_not_found")}</h2>;
  }

  // ✅ Filter programs where this master is included
  const filteredPrograms = Programs.filter((program) => program.masterId === master.id);

  return (
    <div className="masters-page-container">
      <BackTo text={t("masters_title")} />

      <MastersDetailedDescription
        photo={master.photo}
        date={master.credentials}
        name={master.name}
        surname={master.surname}
        credentials={master.credentials}
        description={master.description}
        text1={master.text1}
        onBack={() => navigate('/masters')}
      /> 

      <h2 className="programs-title-masters-page">
        {t("programs_by_master", { master: `${master.name} ${master.surname}` })}
      </h2>

      <div className="masters-programs">
        {filteredPrograms.length > 0 ? (
          filteredPrograms.map((program) => (
            <CourseCard
              key={program.id}
              image={program.image}
              date={program.dateRange}
              title={program.title}
              description={program.description}
              learnMoreLink={`/program/${program.id}`} 
              masters={program.Masters} mastersLink={''}            />
          ))
        ) : (
          <p>{t("no_programs_for_master")}</p>
        )}
      </div>
    </div>
  );
};

export default MasterDetailsPage;
